import { SettlementConfigurationStateType } from '@g2-shared/api-client/generated/settlement-app';

export const SettlementConfigurationStateLabelMapper: Record<
  SettlementConfigurationStateType,
  string
> = {
  [SettlementConfigurationStateType.ACTIVATED]: 'Activated',
  [SettlementConfigurationStateType.CREATED]: 'Created',
  [SettlementConfigurationStateType.DEACTIVATED]: 'Deactivated',
  [SettlementConfigurationStateType.DELETED]: 'Deleted',
  [SettlementConfigurationStateType.FINISHED]: 'Finished',
};
